<template>
  <div class="mt-2">
    <div class="flex justify-between" style="align-items: center;">
      <div class="flex">
      </div>
      <div class="flex">
        <vs-button
          size="small"
          class="flex mx-1"
          @click.prevent="showEditExtensions"
          v-if="hasQueueStatusConnection"
        >
          {{ $t('change_extension') }}
        </vs-button>

        <vs-button color="danger" type="filled" size="small" class="flex mx-1" @click="applyConfig" v-if="queueStatusConfigStatus">{{ $t('apply_config') }}</vs-button>

        <div
          class="btn-group flex mx-1"
        >
          <vs-button
            :type="getModeByType('card')"
            @click.prevent="viewMode = 'card'"
            size="small"
            icon-pack="feather"
            icon="icon-credit-card">
          </vs-button>

          <vs-button
            :type="getModeByType('list')"
            @click.prevent="viewMode = 'list'"
            size="small"
            icon-pack="feather"
            icon="icon-list">
          </vs-button>
        </div>
      </div>
    </div>
    <vs-divider></vs-divider>

    <div class="vx-row">
      <template v-if="viewMode === 'card'">
        <div class="vx-col md:w-2/12 sm:w-3/12 w-full" v-for="(extension, key) in extensions" :key="key">
          <extension-card :extension="extension" :state="state" @listen="listen" @whisper="whisper" @enable="enable(key)" @disable="disable(key)"></extension-card>
        </div>
      </template>

      <template v-if="viewMode === 'list'">
        <div class="vx-col w-full" v-for="(extension, key) in extensions" :key="key">
          <extension-list :extension="extension" @enable="enable(key)" @disable="disable(key)"></extension-list>
        </div>
      </template>

      <template v-if="viewMode === 'table'">
        <div class="vx-col w-full">
          <extension-table :extensions="extensions" @enable="enable" @disable="disable"></extension-table>
        </div>
      </template>

    </div>

    <modal :title="`${queue} - ${$t('extensions')}`" :active.sync="modals.editExtensions" size="xs">
      <div class="vs-con-loading__container">
        <div class="vs-component con-vs-checkbox mb-3 vs-checkbox-primary vs-checkbox-default" v-for="(ext, index) in userExtensions" :key="index">
          <input type="checkbox" class="vs-checkbox--input" :id="'ext' + index" :value="ext" v-model="selectedExtensions">
          <span class="checkbox_x vs-checkbox" style="border: 2px solid rgb(180, 180, 180);">
            <span class="vs-checkbox--check">
              <i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i>
            </span>
          </span>
          <span class="con-slot-label">
            <span>{{ ext }}</span>
          </span>
        </div>
        <vs-divider></vs-divider>
        <div class="flex justify-end">
          <vs-button id="saveExtensionButton" color="primary" type="filled" @click="saveExtensions">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ExtensionCard from '@/views/Shared/Queues/Extensions/Card'
import ExtensionList from '@/views/Shared/Queues/Extensions/List'
import ExtensionTable from '@/views/Shared/Queues/Extensions/Table'
import dndConfig from '@/config/dnd'
import announcementSocket from '@/libs/sockets/announcements'
import Cti from '@/models/Cti'
import User from '@/models/User'
import Modal from '@/components/Modal.vue'
import TimeCondition from '@/models/TimeCondition'
import Swal from 'sweetalert2'

export default {
  name: 'Shared.Queues.Extensions',
  components: {
    Modal,
    ExtensionCard,
    ExtensionList,
    ExtensionTable
  },
  data () {
    return {
      viewMode: 'card', // [card, list],
      displayManageExtension: false,
      userExtensions: [],
      selectedQueue: '',
      selectedExtensions: [],
      modals: {
        editExtensions: false
      },
      queueStatusConfigStatus: false,
      hasQueueStatusConnection: false
    }
  },
  props: {
    server: {
      type: Object,
      required: true
    },
    queue: {
      type: String,
      required: true
    },
    extensions: {
      type: Array,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    extensionNumber: {
      type: [String, Number],
      required: true
    },
    activeExtensions: {
      type: [Array],
      required: true
    },
    runInitialExtensions: {
      type: Function
    }
  },
  computed: {
    servers () { return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {} },
    username () { return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.username : '' }
  },
  mounted () {
    announcementSocket.setNode(this.servers) // Set Node. This will be rejected if node was already set. TODO: Put this on a initial file
    this.loadUserExtensionList()
  },
  methods: {
    async loadUserExtensionList () {
      const response = await User.getUserUsedExtensions({queue: this.queue})
      this.userExtensions = response.data.extensions
      // this.hasQueueStatusConnection = response.data.hasQueueStatusConnection // disable change extension
      this.queueStatusConfigStatus = response.data.queueStatusConfigStatus
    },
    getModeByType (type) {
      return this.viewMode === type ? 'filled' : 'border'
    },
    async saveExtensions () {

      this.$vs.loading({background: 'primary', color: '#fff', container: '#saveExtensionButton', scale: 0.45})

      await Cti.saveExtensions(this.server.domain, {
        queue: this.selectedQueue,
        extensions: this.selectedExtensions
      })
      this.modals.editExtensions = false
      this.queueStatusConfigStatus = true

      Swal.fire({
        icon: 'warning',
        title: this.$t('save_extension_swal_title'),
        html: this.$t('save_extension_swal_html'),
        confirmButtonText: this.$t('confirm')
      })

      this.$vs.loading.close('#saveExtensionButton > .con-vs-loading')
    },
    async enable (key) {
      await Cti.processDnd(this.server.domain, {
        id: 'after',
        data: this.extensions[key].extension,
        option: 1
      })
      announcementSocket.getSocket().emit('refresh_dnd_for_extension', {
        extensionNumber: this.extensions[key].extension,
        username: this.username,
        type: 'enable'
      })
    },
    async disable (key) {
      await Cti.processDnd(this.server.domain, {
        id: dndConfig.status[this.extensions[key].status],
        data: this.extensions[key].extension,
        option: 2
      })
      announcementSocket.getSocket().emit('refresh_dnd_for_extension', {
        extensionNumber: this.extensions[key].extension,
        username: this.username,
        type: 'disable'
      })
    },
    async listen (data) {
      if (this.state.listen === false) {
        if (this.state.whisper === true) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: `Current state is whispering to ${this.state.currentNumber}`,
            confirmButton: this.$t('confirm')
          })
        } else {
          try {
            Cti.listen(this.servers.domain, {
              extension: this.extensionNumber,
              channel: data
            })
            this.state.currentNumber = data
            this.state.listen = true
          } catch (e) {
            this.$vs.notify({
              title:'CTI Notice',
              text:'Listen Error',
              color:'danger',
              position:'top-right'
            })
          }
        }
      } else if (this.state.listen === true) {
        if (this.state.currentNumber === data) {
          this.state.listen = false
          Cti.hangupWithChannel(this.servers.domain, this.extensionNumber)
        } else {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: `Current state is listening to ${this.state.currentNumber}`,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    async whisper (data) {
      if (this.state.whisper === false) {
        if (this.state.listen === true) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: `Current state is listening to ${this.state.currentNumber}`,
            confirmButton: this.$t('confirm')
          })
        } else {
          Cti.whisper(this.servers.domain, {
            extension: this.extensionNumber,
            channel: data
          })
          this.state.currentNumber = data
          this.state.whisper = true
        }
      } else if (this.state.whisper === true) {
        if (this.state.currentNumber === data) {
          this.state.whisper = false
          Cti.hangupWithChannel(this.servers.domain, this.extensionNumber)
        } else {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: `Current state is whispering to ${this.state.currentNumber}`,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    showEditExtensions () {
      this.modals.editExtensions = true
      this.selectedExtensions = this.activeExtensions
      this.selectedQueue = this.queue
    },
    applyConfig () {
      try {
        const response = TimeCondition.apply({queue: this.queue})
        this.queueStatusConfigStatus = false
        this.runInitialExtensions()
        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    }
  }
}
</script>

<style scoped>

#saveExtensionButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
